import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	standardPlanSlideHeader: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.benefits-slide.standard-plan-slide-header',
		defaultMessage: 'The Standard plan also includes:',
		description: 'Header detailing what standard plan includes',
	},
	onCallManagement: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.benefits-slide.on-call-management',
		defaultMessage: 'On-call management',
		description: 'Benefit title for on-call management',
	},
	createCustomRules: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.benefits-slide.create-custom-rules',
		defaultMessage: 'Create custom routing rules and escalation\u00A0policies.',
		description: 'Benefit description for custom routing rules',
	},
	unlimitedEmailNotifications: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.benefits-slide.unlimited-email-notifications',
		defaultMessage: 'Unlimited email notifications',
		description: 'Benefit title for unlimited email notifications',
	},
	updateEveryone: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.benefits-slide.update-everyone',
		defaultMessage: 'Update everyone about activity on requests.',
		description: 'Benefit description for keeping everyone updated',
	},
	businessHourSupport: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.benefits-slide.business-hour-support',
		defaultMessage: 'Business hour support',
		description: 'Benefit title for business hour support',
	},
	getSupport: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.benefits-slide.get-support',
		defaultMessage: 'Get support from Atlassian’s team of experts.',
		description: 'Benefit description for getting Atlassian support',
	},
	userRolesAndPermissions: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.benefits-slide.user-roles-and-permissions',
		defaultMessage: 'User roles & permissions',
		description: 'Benefit title for user roles and permissions',
	},
	haveMoreControl: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.benefits-slide.have-more-control',
		defaultMessage:
			'Have more control over which users have access to different projects and actions.',
		description: 'Benefit description for user roles and permissions',
	},
	anonymousAccess: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.benefits-slide.anonymous-access',
		defaultMessage: 'Anonymous access',
		description: 'Benefit title for anonymous access',
	},
	giveSecureAccess: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.benefits-slide.give-secure-access',
		defaultMessage: 'Give secure access to people outside your\u00A0team.',
		description: 'Benefit description for anonymous access',
	},
	customProjectRoles: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.benefits-slide.custom-project-roles',
		defaultMessage: 'Custom project roles',
		description: 'Benefit title for custom project roles',
	},
	getMoreGranularity: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.benefits-slide.get-more-granularity',
		defaultMessage:
			'Get more granularity by creating custom project roles with specific permissions.',
		description: 'Benefit description for custom project roles',
	},
	dataResidency: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.benefits-slide.data-residency',
		defaultMessage: 'Data residency',
		description: 'Benefit title for data residency',
	},
	chooseDataHosting: {
		id: 'upgrade-onboarding-experiment.upgrade-onboarding-modal.carousel.benefits-slide.choose-data-hosting',
		defaultMessage: 'Choose where you want your data hosted.',
		description: 'Benefit description for data residency',
	},
});
